/**
 * @fileoverview GET handler for the "/engagement/preset_iam_templates" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPresetIamTemplates } from "./constants";
import type { EngagementPresetIamTemplatesParams, EngagementPresetIamTemplatesResult } from "./types";
import { isEngagementPresetIamTemplatesResult } from "./validators";

export const getDataTableEngagementPresetIamTemplates = reactQueryTableFetcherAdapter(
  engagementPresetIamTemplates,
  (
    signal: AbortSignal,
    { query = {} }: EngagementPresetIamTemplatesParams
  ): Promise<EngagementPresetIamTemplatesResult> => {
    return fetch(
      "/engagement/preset_iam_templates",
      "GET",
      {
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isEngagementPresetIamTemplatesResult
);
